import React from 'react';
import { connect } from 'react-redux'
import { Spin } from 'antd';
import {OwlRepository} from '../../redux/OwlActions';

/** Компонента, отображающая label, из virtuoso. Значение label 
 * определяется: rdfs:label у свойства, с учётом языка, 
 * либо (если не найден в virtuoso) prefix:code.
 * В начале label отображает nameSpace:code (например, rdfs:labеl или skos:prefLabel),
 * в этот момент запрашивается информация о значении label для языка, если 
 * значение найдено, то отображается найденноей значения, если нет, то запрашивается
 * значение без указания языка, если оно найдено, то отображается, если нет, 
 * то остаётся  nameSpace:code */
const Loaded = ({ns, code}) => <span>{ns+":"+code}&nbsp;<Spin size="small" /></span>

const Label = ({ns, code, lang, values}) => {
    let label = ns+":"+code;
    if (Array.isArray(values)){
        const defaultLabel = values.filter(item => (item.label["xml:lang"]=="")||( typeof item.label["xml:lang"] === 'undefined'));
        const labels = values.filter(item => item.label["xml:lang"]==lang);
        if (labels.length>0){
            label = labels[0].label.value;
        } else {
            if (defaultLabel.length>0) label = defaultLabel[0].label.value;
        }
    }
    return (
        <span>{label}</span>
    )
}
class LabelInOwl extends React.Component {
    state = {
        loaded: true,
        prefix: "",
        code: "",
        ns: "",
        values: undefined
    };

    componentWillMount() {
        const { values } = this.state;
        if ((values==undefined)|| (values==null)) 
            this.makeLabel();
    }

    componentWillReceiveProps(nextProps){
        const { values } = this.state;
        if ((values==undefined)|| (values==null)) 
            this.makeLabel();
    }

    makeLabel () {
        const {vset, iri, prefix, nameSpace, lang, graph} = this.props;
        //Найдем префикс, ns и code (проверяем доступность сокращений)
        const xmlns = vset.xmlns.filter(item => iri.indexOf(item.uri)==0)
        const isExist = Array.isArray(xmlns) && xmlns.length>0;
        const lastIndexOf = (isExist)? xmlns[0].uri.length: Math.max(iri.lastIndexOf("#"), iri.lastIndexOf("/"))+1;
        const rPrefix = (prefix)?prefix: iri.substring(0, lastIndexOf);
        const ns = (nameSpace)? nameSpace: (isExist)? xmlns[0].ns: "ns"+new Date().toISOString().slice(17, 23);
        const code = iri.substring(lastIndexOf);
        this.setState({prefix: rPrefix, code, ns, loaded: true});
        this.props.dispatch(OwlRepository.loadLabels(iri, lang, graph))
            .then ((response) =>{
                //console.log("Done!", response);
                const {results} = response;
                const {bindings} = results;
                this.setState({loaded: false, values: bindings});
            })
            .catch(e => { 
                console.log("Error!", e);
            });
}

    render(){
        //console.log(this);
        const Component = (this.state.loaded)? Loaded: Label;
        return(
            <Component {...this.props} {...this.state} />
        )
    }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vowl, vset} = state;
    //Параметры, которые могут прийти из настроек
    const {graph, iri, lang } = props;
    const rGraph = (graph)? graph: vset.graph;
    //Если iri пусто, то используем http://www.w3.org/2000/01/rdf-schema#label
    const rIRI = (iri)? iri: "http://www.w3.org/2000/01/rdf-schema#label";
    //Ищем считанные из значения свойств
    const vGraphs = (vowl && vowl.description)?vowl.description.filter(item => item.graph==rGraph):[];
    const vGraph =(Array.isArray(vGraphs) && vGraphs.length>0)? vGraphs[0]: {};
    //Получим описание свойства. В описании должно быть IRI свойства, prefix (т.е. uri xmlns), code и строковые значения
    const items = (vGraph.subjects)?vGraph.subjects.filter(item => item.iri==rIRI): [];
    const property = (Array.isArray(items) && items.length>0)? items[0]: {};
    return {
        graph: rGraph,
        lang: (lang)?lang: vset.lang,
        iri: rIRI,
        ...property,
        vset
    };
}

export default connect(mapStateToProps)(LabelInOwl);